import {
  Card,
  Table,
  Stack,
  Paper,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  Box,
  IconButton,
  Chip,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PersonIcon from '@mui/icons-material/Person';
import Scrollbar from '../scrollbar';
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/user';
import { USERS_TABLE_HEAD, PAGE_SIZE_OPTIONS } from '../../utils/storageConstants';

export default function UsersTable({
  users,
  filteredUsers,
  usersOrder,
  usersOrderBy,
  usersFilterName,
  usersPage,
  usersRowsPerPage,
  selectedUsers,
  usersIsNotFound,
  usersEmptyRows,
  onRequestSort,
  onFilterByName,
  onChangePage,
  onChangeRowsPerPage,
  onSelectAllClick,
  onSelectClick,
}) {
  return (
    <Card>
      <Box sx={{ p: 2, pb: 0 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
          <Typography variant="h6">
            <PersonIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
            Users (Employees & Clients)
          </Typography>
        </Stack>
        <UserListToolbar
          numSelected={selectedUsers.length}
          filterName={usersFilterName}
          onFilterName={onFilterByName}
          placeholder="Search users..."
        />
      </Box>
      <Scrollbar>
        <TableContainer sx={{ minWidth: 600 }}>
          <Table>
            <UserListHead
              order={usersOrder}
              orderBy={usersOrderBy}
              headLabel={USERS_TABLE_HEAD}
              rowCount={users?.length}
              numSelected={selectedUsers.length}
              onRequestSort={onRequestSort}
              onSelectAllClick={onSelectAllClick}
            />
            <TableBody>
              {filteredUsers
                .slice(usersPage * usersRowsPerPage, usersPage * usersRowsPerPage + usersRowsPerPage)
                .map((row) => {
                  const { id, name, email, assignedBucket } = row;
                  const selectedUser = selectedUsers.indexOf(name) !== -1;

                  return (
                    <TableRow hover key={id} tabIndex={-1} role="checkbox" selected={selectedUser}>
                      <TableCell padding="checkbox">
                        <Checkbox checked={selectedUser} onChange={(event) => onSelectClick(event, name)} />
                      </TableCell>
                      <TableCell align="left">{name}</TableCell>
                      <TableCell align="left">{email}</TableCell>
                      <TableCell align="left">
                        {assignedBucket ? (
                          <Chip label={assignedBucket} color="info" size="small" />
                        ) : (
                          <Chip label="No bucket assigned" color="default" size="small" />
                        )}
                      </TableCell>
                      <TableCell align="left">
                        <IconButton>
                          <MoreVertIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {usersEmptyRows > 0 && (
                <TableRow style={{ height: 53 * usersEmptyRows }}>
                  <TableCell colSpan={7} />
                </TableRow>
              )}
            </TableBody>

            {usersIsNotFound && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                    <Paper sx={{ textAlign: 'center' }}>
                      <Typography variant="h6" paragraph>
                        Not found
                      </Typography>
                      <Typography variant="body2">
                        No results found for &nbsp;
                        <strong>&quot;{usersFilterName}&quot;</strong>.
                        <br /> Try checking for typos or using complete words.
                      </Typography>
                    </Paper>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
      </Scrollbar>
      <TablePagination
        rowsPerPageOptions={PAGE_SIZE_OPTIONS}
        component="div"
        count={users?.length}
        rowsPerPage={usersRowsPerPage}
        page={usersPage}
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
      />
    </Card>
  );
}
